import axios from "axios";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Input,
  MenuItem,
  Select,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import { GMB } from "../../../services/gmbApiConfig";
import { useSelector } from "react-redux";
import {
  selectAccountId,
  selectLocationId,
} from "../../../Store/Gmb/gmbStoreSlice";

const AddButtonToPost = ({ onSelectValue, onTextValueChange }) => {
  const accountId = useSelector(selectAccountId);
  const locationId = useSelector(selectLocationId);

  const [linkUrl, setLinkUrl] = useState("");
  const [options, setOptions] = useState([]);
  const [currentOption, setCurrentOption] = useState("None");

  const [error, setError] = useState(null);
  const fetchActionButtonType = async () => {
    try {
      const response = await axios.post(
        `${GMB.ENDPOINTS.POSTS.GET_ACTION_TYPE}`,
        { account_id: accountId, location_id: locationId },
        {
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setOptions([
          "None",
          ...response?.data?.body?.map((item) =>
            item?.action_type?.toString()?.toLowerCase()?.replace("_", " ")
          ),
        ]);
      }
    } catch (e) {
      console.error("error fetching action type", e?.message);
      setError(e?.message);
    }
  };

  useEffect(() => {
    fetchActionButtonType();
  }, []);

  if (error) {
    return null;
  }

  return (
    <>
      <FormControl sx={{ minWidth: 120 }}>
        <span className="mb-1 opacity-70">Add a button (optional)</span>
        <Select
          value={currentOption || "None"}
          className="capitalize"
          onChange={(e) => {
            const value = e.target.value;
            setCurrentOption(value);
            onSelectValue(value === "None" ? null : value.toUpperCase().replace(" ", "_"));
          }}
        >
          {options?.map((value) => (
            <MenuItem key={value} className="capitalize" value={value}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {currentOption !== "None" && (
        <TextField
          id="outlined-basic"
          label="Link for your button*"
          sx={{
            width: "100%",
          }}
          variant="outlined"
          value={linkUrl}
          onChange={(e) => {
            setLinkUrl(e.target.value);
            onTextValueChange({
              actionType: currentOption.toUpperCase().replace(" ", "_"),
              url: e.target.value
            });
          }}
        />
      )}
    </>
  );
};

export default AddButtonToPost;
